(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-1925"]) return;
  try {
    
  (function() {
    var smoothAnchorLinks = document.querySelectorAll('a[href*="#"]');

    smoothAnchorLinks.forEach(function(link) {
      link.addEventListener('click', function(event) {
        if (!link.hash) return;

        var targetUrl = new URL(link.href, window.location.origin);
        var samePage = targetUrl.origin === window.location.origin && targetUrl.pathname === window.location.pathname;
        if (!samePage) return;

        var targetElement = document.querySelector(targetUrl.hash);
        if (!targetElement) return;

        event.preventDefault();
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', targetUrl.hash);
      });
    });

    var desktopDropdownItem = document.querySelector('[data-shop-now-item]');
    var desktopDropdownToggle = document.querySelector('[data-shop-now-toggle]');
    var desktopDropdown = document.querySelector('[data-shop-now-dropdown]');
    var desktopMediaQuery = window.matchMedia('(min-width: 990px)');

    if (desktopDropdownItem && desktopDropdownToggle && desktopDropdown) {
      function isDesktop() {
        return desktopMediaQuery.matches;
      }

      function openDesktopDropdown() {
        if (!isDesktop()) return;
        desktopDropdownItem.classList.add('is-open');
        desktopDropdownToggle.setAttribute('aria-expanded', 'true');
      }

      function closeDesktopDropdown() {
        desktopDropdownItem.classList.remove('is-open');
        desktopDropdownToggle.setAttribute('aria-expanded', 'false');
      }

      desktopDropdownToggle.addEventListener('click', function(event) {
        if (!isDesktop()) return;
        event.preventDefault();
        if (desktopDropdownItem.classList.contains('is-open')) closeDesktopDropdown();
        else openDesktopDropdown();
      });

      desktopDropdownItem.addEventListener('focusout', function(event) {
        if (!desktopDropdownItem.contains(event.relatedTarget)) closeDesktopDropdown();
      });

      document.addEventListener('click', function(event) {
        if (!desktopDropdownItem.contains(event.target)) closeDesktopDropdown();
      });

      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') closeDesktopDropdown();
      });

      desktopMediaQuery.addEventListener('change', closeDesktopDropdown);
    }

    var overlay = document.getElementById('header-1925-menu-overlay');
    var trigger = document.querySelector('[data-menu-trigger]');
    var closeButtons = document.querySelectorAll('[data-close-overlay]');
    if (overlay && trigger) {
      function openMenu() {
        overlay.removeAttribute('inert');
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
      }
      function closeMenu() {
        overlay.classList.remove('is-open');
        overlay.setAttribute('inert', '');
        overlay.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
      }
      trigger.addEventListener('click', function() {
        if (overlay.classList.contains('is-open')) closeMenu();
        else openMenu();
      });
      closeButtons.forEach(function(btn) {
        btn.addEventListener('click', closeMenu);
      });
      overlay.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeMenu();
      });
    }
  })();

  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      connectedCallback() {
        /* Siempre el propio <sticky-header> (nunca querySelector .section-header: el wrapper del section también lo usa). */
        this.header = this;
        if (!this.header) return;
        this.stickyType = this.getAttribute('data-sticky-type') || 'on-scroll-up';
        this.headerIsAlwaysSticky = this.stickyType === 'always';
        this.headerBounds = {};
        this.desktopMql = window.matchMedia('(min-width: 990px)');
        this.setHeaderHeight();
        this._onResizeMql = this._onResizeMql.bind(this);
        this.desktopMql.addEventListener('change', this._onResizeMql);
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
        if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.preventReveal = false;
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
        this.createObserver();
        requestAnimationFrame(() => {
          this.setHeaderHeight();
          requestAnimationFrame(() => this.setHeaderHeight());
        });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
        if (this.desktopMql) this.desktopMql.removeEventListener('change', this._onResizeMql);
      }

      _onResizeMql() {
        if (!this.desktopMql.matches) this.resetHeaderScrollState();
      }

      resetHeaderScrollState() {
        if (!this.header) return;
        this.header.classList.remove(
          'scrolled-past-header',
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate'
        );
      }

      setHeaderHeight() {
        if (this.header) document.documentElement.style.setProperty('--header-height', this.header.offsetHeight + 'px');
      }

      createObserver() {
        const observer = new IntersectionObserver((entries) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
        observer.observe(this.header);
      }

      /**
       * Umbral “pasé el header”: solo altura medida / --header-height.
       * No usar intersectionRect.bottom: con header absolute + root height 0 (edition-landing / index)
       * el rect suele inflarse y el menú nunca llega a ocultarse.
       */
      scrollPastThreshold() {
        const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        const fromCss = parseInt(raw, 10);
        const measured = this.header && this.header.offsetHeight ? this.header.offsetHeight : 0;
        const h = (Number.isFinite(fromCss) && fromCss > 0 ? fromCss : measured) || 72;
        return Math.max(h, 48);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (!this.desktopMql.matches) {
          this.resetHeaderScrollState();
          this.currentScrollTop = scrollTop;
          return;
        }

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
          this.currentScrollTop = scrollTop;
          return;
        }

        const threshold = this.scrollPastThreshold();
        const scrollingDown = scrollTop > this.currentScrollTop;
        const scrollingUp = scrollTop < this.currentScrollTop;

        if (scrollTop <= 1) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(() => {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
          });
        } else if (scrollingUp) {
          this.header.classList.add('scrolled-past-header');
          requestAnimationFrame(() => {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
          });
        } else if (scrollingDown && scrollTop > threshold) {
          this.header.classList.add('scrolled-past-header');
          requestAnimationFrame(() => {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'shopify-section-header-hidden');
          });
        }

        this.currentScrollTop = scrollTop;
      }
    }
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-original"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
